"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var _Icon = require("../../../../components/Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SearchIcon = function SearchIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: "search-24",
    className: "text-black"
  }));
};
var _default = SearchIcon;
exports.default = _default;